import { Navigate, Outlet, useLocation } from "react-router-dom";
import { InactivityGuard } from "@/features/auth/InactivityGuard";
import { ForcePasswordChangePage } from "@/features/auth/ForcePasswordChangePage";
import { RevokedSessionSync } from "@/features/auth/RevokedSessionSync";
import { useAuthStore } from "@/stores/auth-store";

export function ProtectedRoute() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const mustChangePassword = useAuthStore((s) => s.user?.must_change_password ?? false);
  const location = useLocation();

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return (
    <>
      <InactivityGuard />
      <RevokedSessionSync />
      {/* Signed in with an admin-issued temporary password: nothing else
          renders (and the server refuses every non-/auth call) until it is
          changed. */}
      {mustChangePassword ? <ForcePasswordChangePage /> : <Outlet />}
    </>
  );
}

export function GuestRoute() {
  const accessToken = useAuthStore((s) => s.accessToken);
  if (accessToken) return <Navigate to="/" replace />;
  return <Outlet />;
}
